<app-date-picker
	[label]="label"
	[ngModel]="closingDate$ | async"
	[skeletonLoading]="skeletonLoading"
	(ngModelChange)="onChange($event)"
	[orientation]="orientation"
	[labelIcon]="AI_ICON"
	[labelToolTip]="(closingDateFieldMapping$ | async) ? AI_TOOLTIP : ''"
	[labelIconClasses]="AI_CLASSES"
	(focus)="_onFocus()"
	[minDate]="minDate$ | async"
	[minDateErrorLabel]="minDateLabel$ | async"
	[testHook]="testHooks.ClosingDatePicker"
/>
